export default __webpack_public_path__ + "static/media/calendar.31d6cfe0.svg";